import React from "react";
import ct from "class-types.macro";
import { CarouselFeatureGroup } from "~/common/Store/models/Brand";
import BrandCarousel from "~/Brands/ExpandedFeatureGroupCarousel/BrandCarousel";
import Item from "~/Brands/ExpandedFeatureGroupCarousel/Item";
import Icon from "~/common/Icons/Standard";
import tracking from "~/Gtm/Tracking/tracking";

interface Props {
  featureGroup: CarouselFeatureGroup;
}

const ExpandedFeatureGroupCarousel = ({ featureGroup }: Props) => {
  const containerWrapperStyle = ct(
    "mr-0",
    "ml-0",
    "pl-0",
    "pt-8",
    "w-full",
    "xs:px-8",
    featureGroup.includeBackground ? ct("bg-gray-50") : ct("bg-white")
  );

  const listWrapperStyle = ct(
    "flex",
    "mb-0",
    "ml-0",
    "relative",
    featureGroup.carouselMembers.length <= 5 ? ct("lt:justify-around") : ""
  );

  const listContentStyle = ct(
    "last:mr-5",
    "p-4",
    "w-1/2",
    "xsl:w-1/3",
    "xs:last:mr-0",
    "md:w-3/12",
    "lt:w-1/5",
    "xxl:w-2/12"
  );

  const carouselWrapperStyle = ct(
    "border-gray-200",
    "border-solid",
    "border",
    "border-t-0",
    "border-r-0",
    "border-l-0",
    "border-b",
    "my-0",
    "relative",
    "w-full",
    "xs:border-0",
    "xs:-mr-2-1/2",
    "xs:-ml-2-1/2",
    "lt:-mr-4"
  );

  const buttonStyle = ct(
    "bg-transparent",
    "border-0",
    "cursor-auto",
    "hidden",
    "h-full",
    "mx-0",
    "focus:outline-none",
    "absolute",
    "top-0",
    "xs:inline-block"
  );

  const iconStyle = ct(
    "cursor-pointer",
    "h-6",
    "fill-current",
    "text-green-400",
    "hover:text-green-600",
    "w-6"
  );

  const anchorStyle = ct("flex", "flex-col", "self-center", "pb-0");

  const imageStyle = ct("rounded");

  const paragraphStyle = ct(
    "block",
    "font-semibold",
    "text-sm",
    "leading-none",
    "mb-0",
    "mt-2-1/2",
    "max-h-10",
    "min-h-10",
    "text-center"
  );

  return (
    <div
      className={carouselWrapperStyle}
      style={{ width: "calc(100% + 20px)" }}
    >
      <div className={containerWrapperStyle}>
        <h3 className="grid-featured__title" style={{ textAlign: "center" }}>
          {featureGroup?.title}
        </h3>
        <BrandCarousel
          slideRight={({ onClick }) => (
            <button
              aria-hidden="true"
              className={ct("pr-2", "right-0", buttonStyle)}
              type="button"
              onClick={onClick}
            >
              <Icon name="right-open" className={iconStyle} />
            </button>
          )}
          slideLeft={({ onClick }) => (
            <button
              aria-hidden="true"
              className={ct("pl-2", "left-0", buttonStyle)}
              type="button"
              onClick={onClick}
            >
              <Icon name="left-open" className={iconStyle} />
            </button>
          )}
          listWrapperProps={{
            className: listWrapperStyle,
          }}
        >
          {featureGroup.carouselMembers.map((member) => (
            <Item
              key={member.url}
              listItemProps={{ className: listContentStyle }}
            >
              <>
                <tracking.a
                  href={member.url}
                  title={member.description}
                  className={anchorStyle}
                  data-track={featureGroup?.title}
                  data-track-ei={member.url}
                  enableTracking={
                    featureGroup?.title.trim() === "Trending Flavors"
                  }
                >
                  <img
                    alt={member.description}
                    src={member.imagePath}
                    className={imageStyle}
                    loading="lazy"
                  />
                  <p className={paragraphStyle}>{member.description}</p>
                </tracking.a>
              </>
            </Item>
          ))}
        </BrandCarousel>
      </div>
    </div>
  );
};
export default ExpandedFeatureGroupCarousel;
